import { Box, IconButton, useMediaQuery, useTheme } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { useRef } from "react";

const HeroCarousel = ({ images }: { images: string[] }) => {
  const scrollRef = useRef<HTMLDivElement>(null);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const scrollBy = (offset: number) => {
    scrollRef.current?.scrollBy({ left: offset, behavior: "smooth" });
  };

  return (
    <Box
      px={{ xs: 2, sm: 3, md: 4 }}
      sx={{
        position: "relative",
        mb: 4,
        borderRadius: 4,
        overflow: "hidden",
        height: 280,
      }}
    >
      {/* Scrollable Image Row */}
      <Box
        ref={scrollRef}
        sx={{
          display: "flex",
          gap: 2,
          overflowX: "auto",
          scrollBehavior: "smooth",
          height: "100%",

          width: "100%",
          scrollbarWidth: "none",
          "&::-webkit-scrollbar": { display: "none" },
        }}
      >
        {images.map((src, i) => (
          <Box
            key={i}
            component="img"
            src={src}
            sx={{
              flex: "0 0 65%",
              height: "100%",
              objectFit: "cover",
              borderRadius: 4,
            }}
          />
        ))}
      </Box>

      {/* Nav: LEFT */}
      <IconButton
        onClick={() => scrollBy(-400)}
        sx={{
          position: "absolute",
          top: "50%",
          left: 12,
          transform: "translateY(-50%)",
          backgroundColor: "rgba(255,255,255,0.9)",
          border: "1px solid #ddd",
          borderRadius: "8px",
          zIndex: 10,
          boxShadow: "0px 2px 6px rgba(0,0,0,0.1)",
          "&:hover": { backgroundColor: "#f3f4f6" },
        }}
      >
        <ChevronLeftIcon />
      </IconButton>

      {/* Nav: RIGHT */}
      <IconButton
        onClick={() => scrollBy(400)}
        sx={{
          position: "absolute",
          top: "50%",
          right: 12,
          transform: "translateY(-50%)",
          backgroundColor: "rgba(255,255,255,0.9)",
          border: "1px solid #ddd",
          borderRadius: "8px",
          zIndex: 10,
          boxShadow: "0px 2px 6px rgba(0,0,0,0.1)",
          "&:hover": { backgroundColor: "#f3f4f6" },
        }}
      >
        <ChevronRightIcon />
      </IconButton>
    </Box>
  );
};

export default HeroCarousel;
